export default __webpack_public_path__ + "static/media/midasi_point_zh_tw_pc@2x.ef04571e.png";